import { Collapsible } from '@chakra-ui/react'
import { useAtom } from 'jotai'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import useOutsideClick from '@/hooks/useOutsideClick'
import Search from '@/pages/components/search'
import { searchAtom } from '@/store/app/AppAtom'
import { langsAtom, showOptionsAtom } from '@/store/translate'
import { deepClone } from '@/utils'

import OptionsGroup from './components/optionsGroup'
import SelectedOptions from './components/selectedOptions'

const MultiSelect = () => {
    const { t } = useTranslation()
    const [search] = useAtom(searchAtom)
    const [langs] = useAtom(langsAtom)
    const [data, setData] = useState(deepClone(langs))
    const [showOptions, setShowOptions] = useAtom(showOptionsAtom)
    const ref = useRef(null)

    useOutsideClick(ref, () => setShowOptions(false))

    useEffect(() => {
        if (!search) {
            setData(deepClone(langs))
        } else {
            setData(deepClone(langs.filter((item) => item.languageEnglishName.toLowerCase().includes(search.toLowerCase()))))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search])

    useEffect(() => {
        setData(deepClone(langs))
    }, [langs])

    useEffect(() => {
        return () => {
            setShowOptions(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box pos="relative" zIndex="1" ref={ref}>
            <Box>
                <Text fontSize="12px" color="rgba(84, 79, 64, 0.7)" _dark={{ color: 'rgba(255, 255, 255, 0.7)' }} pb="8px">
                    {t('translate.multiSelect.title')}
                </Text>
            </Box>
            <SelectedOptions />
            <Collapsible.Root open={showOptions}>
                <Collapsible.Content>
                    <Box
                        backgroundColor="white"
                        border="2px solid rgb(239, 239, 237)"
                        borderRadius="4px"
                        boxShadow="0px 4px 10px 1px rgba(84, 79, 64, 0.14)"
                        mt="4px"
                        p="0 12px"
                        position="absolute"
                        bottom="-455px"
                        left="0"
                        width="100%"
                        _dark={{
                            backgroundColor: 'black',
                            borderColor: 'rgba(84, 79, 64, 0.4)',
                            boxShadow: '0px 4px 10px 1px rgb(0, 0, 0)',
                        }}
                    >
                        <Box pt="16px" pb="16px">
                            <Search placeholder={t('translate.multiSelect.searchPlaceholder')} />
                        </Box>
                        <Box height="380px" overflow="auto">
                            <OptionsGroup
                                title={t('translate.multiSelect.mostPopular')}
                                data={data.filter((item) => item.commonLanguage)}
                            />
                            <OptionsGroup title={t('translate.multiSelect.other')} data={data.filter((item) => !item.commonLanguage)} />
                        </Box>
                    </Box>
                </Collapsible.Content>
            </Collapsible.Root>
        </Box>
    )
}

export default MultiSelect
